/* eslint max-classes-per-file: 0 */

import {
  KimVariant as Data,
  KimVariantCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class KimVariantApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'kims_variants';

  protected readonly hasFinishSlash = false;
}
